import { render } from "./Dietitian.vue?vue&type=template&id=142ab907&scoped=true"
import script from "./Dietitian.vue?vue&type=script&lang=ts"
export * from "./Dietitian.vue?vue&type=script&lang=ts"

import "./Dietitian.vue?vue&type=style&index=0&id=142ab907&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-142ab907"

export default script